var render = function render(){var _vm=this,_c=_vm._self._c;return _c('GmapMap',{ref:"mapRef",attrs:{"center":_vm.map.center,"zoom":_vm.map.zoom,"map-type-id":"roadmap","options":{
        mapTypeControl: false,
        gestureHandling: 'greedy',
    }}},_vm._l((_vm.markers),function(marker,index){return _c('GmapMarker',{key:`map-marker-${index}`,attrs:{"position":marker.position,"icon":_vm.getMarkerIcon(marker)}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }